/* src/components/landing/LpTestimonials.jsx */
import React from 'react';
import { TESTIMONIALS } from '../../data/landing';

export default function LpTestimonials({ addReveal, revealStyle }) {
  return (
    <section id="depoimentos" className="s-pad" style={{ padding: '120px 0', background: 'var(--surface)' }}>
      <div className="container">
        <div ref={addReveal} style={{ ...revealStyle, textAlign: 'center', maxWidth: 600, margin: '0 auto 64px' }}>
          <span className="section-label">Depoimentos</span>
          <h2 className="serif s-title" style={{ fontSize: '2.8rem', marginBottom: 16 }}>Quem usa, recomenda</h2>
        </div>
        <div className="g3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          {TESTIMONIALS.map((t, i) => (
            <div key={i} ref={addReveal} style={{ ...revealStyle, transitionDelay: `${0.1 * (i + 1)}s`, background: '#fff', borderRadius: 'var(--radius)', padding: 32, border: '1px solid var(--border)' }}>
              <div style={{ color: 'var(--gold)', fontSize: '0.9rem', marginBottom: 16, letterSpacing: 2 }}>★★★★★</div>
              <p style={{ fontSize: '0.95rem', lineHeight: 1.7, marginBottom: 24, fontStyle: 'italic' }}>{t.text}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.85rem', color: '#fff', background: t.cor }}>{t.iniciais}</div>
                <div>
                  <strong style={{ display: 'block', fontWeight: 600, fontSize: '0.85rem' }}>{t.nome}</strong>
                  <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>{t.cargo}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
